export default {
  title: 'Artikelen',
};
